var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper layout-content-navbar"},[_c('div',{staticClass:"layout-container"},[_c('MenuBar',{directives:[{name:"show",rawName:"v-show",value:(_vm.logged),expression:"logged"}]}),_c('div',{staticClass:"layout-page"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }